import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pay-monthly-grid',
  templateUrl: './pay-monthly-grid.component.html',
  styleUrls: ['./pay-monthly-grid.component.css']
})
export class PayMonthlyGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-grid/pay-monthly-grid.component.ts